function ScheduledJobsCtrl($scope,$state){

	// get account id filter from parameters - currently not in use
	$scope.accountId = parseInt($state.params.accountId);
	$scope.jobs = [];


	angular.element(document).ready( function (){
       	store.fetch({
       		method : 'GET',
       		url : '/ag/runningJobs',
       		success: function(data, status, headers, config) {
       			$scope.jobs = data;
    		}
    	});
    });


    $scope.viewJobDetails = function(selectedVersion, jobName){
        var headers = {
            'x-server-type': selectedVersion
        };

        $scope.selectedJob = jobName;
        store.fetch({
            method : 'GET',
            headers: headers,
            url : '/ag/jobInfo?job=' + jobName + "&authenticityToken=" + authenticityToken,
            success: function(data) {
                $scope.jobInfo = (data == "null") ? null : data;
            }
        });
    };

    $scope.triggerJob = function(selectedVersion, jobName) {
        var headers = {
            'x-server-type': selectedVersion
        };

        var requestUrl = '/ag/triggerScheduledJob?jobSimpleName=' + jobName;

        store.fetch({
            method: 'POST',
            url: requestUrl,
            headers: headers
        });
    };

}